import { Link } from "react-router-dom";
import { POLICY_LINKS } from "../PoliciesLinks/PoliciesLinks";

const FooterPolicies = () => {
  return (
    <footer className="text-white py-4 w-full bg-neutral-700">
      <div className={`flex flex-col items-center gap-2 text-xs sm:flex-row sm:justify-center sm:gap-6`}>
        {POLICY_LINKS.map(link => (
          <Link key={link.type} to={link.path} className="hover:underline">
            {link.label}
          </Link>
        ))}
      </div>
    </footer>
  );
};

export default FooterPolicies;
